import React, { useState } from "react";
import { API } from "@/lib/api";
import { ChevronLeft, ChevronRight, ImageOff, Maximize2 } from "lucide-react";
import PhotoLightbox from "@/components/PhotoLightbox";

const resolveUrl = (p) => (/^https?:\/\//i.test(p) ? p : `${API}/files/${p}`);

export default function PhotoGallery({ paths = [] }) {
  const [i, setI] = useState(0);
  const [lightbox, setLightbox] = useState(false);
  if (!paths.length) {
    return (
      <div className="aspect-video rounded-xl bg-muted grid place-items-center text-muted-foreground gap-2 border border-border">
        <ImageOff size={28} />
        <span className="text-sm">No photos</span>
      </div>
    );
  }
  const prev = () => setI((v) => (v - 1 + paths.length) % paths.length);
  const next = () => setI((v) => (v + 1) % paths.length);
  return (
    <>
      <div className="relative rounded-xl overflow-hidden border border-border bg-muted group" data-testid="photo-gallery">
        <button
          type="button"
          className="block w-full"
          onClick={() => setLightbox(true)}
          aria-label="Open photo fullscreen"
          data-testid="gallery-open-lightbox"
        >
          <img src={resolveUrl(paths[i])} alt={`photo-${i}`} className="w-full aspect-video object-cover" />
        </button>
        <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            type="button"
            onClick={() => setLightbox(true)}
            className="w-9 h-9 rounded-full bg-black/60 backdrop-blur text-white grid place-items-center hover:bg-black/80"
            aria-label="Zoom"
          >
            <Maximize2 size={14} />
          </button>
        </div>
        {paths.length > 1 && (
          <>
            <button onClick={prev} className="absolute top-1/2 -translate-y-1/2 left-3 w-10 h-10 rounded-full bg-white/85 hover:bg-white grid place-items-center shadow" data-testid="gallery-prev">
              <ChevronLeft size={18} />
            </button>
            <button onClick={next} className="absolute top-1/2 -translate-y-1/2 right-3 w-10 h-10 rounded-full bg-white/85 hover:bg-white grid place-items-center shadow" data-testid="gallery-next">
              <ChevronRight size={18} />
            </button>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
              {paths.map((_, k) => (
                <span key={k} className={`w-2 h-2 rounded-full transition-all ${k === i ? "bg-white w-6" : "bg-white/50"}`} />
              ))}
            </div>
          </>
        )}
      </div>
      <PhotoLightbox open={lightbox} onClose={() => setLightbox(false)} paths={paths} index={i} onIndexChange={setI} />
    </>
  );
}
